import type { AgentContent, TextContent } from '@startech/openapi'

const normalizeText = (text: string): string => {
  const lines = text.split('\n')
  const normalizedLines: string[] = []
  let previousLineWasBlank = false

  for (const line of lines) {
    const isBlank = line.trim().length === 0
    if (isBlank) {
      if (!previousLineWasBlank) {
        normalizedLines.push('')
      }
      previousLineWasBlank = true
      continue
    }
    normalizedLines.push(line)
    previousLineWasBlank = false
  }

  return normalizedLines.join('\n').trim()
}

const toNormalizedTextContent = (content: TextContent): TextContent | undefined => {
  const normalizedText = normalizeText(content.text)
  if (!normalizedText) {
    return undefined
  }

  return {
    ...content,
    text: normalizedText,
  }
}

export const enrichAgentContents = (contents: AgentContent[]): AgentContent[] => {
  const enriched: AgentContent[] = []

  for (const content of contents) {
    if (content.type !== 'text') {
      enriched.push(content)
      continue
    }

    const normalizedTextContent = toNormalizedTextContent(content)
    if (normalizedTextContent) {
      enriched.push(normalizedTextContent)
    }
  }

  return enriched
}
